import deleteColumns from './delete-columns'
import deleteValues from './delete-values'

const deleteChallenges = [deleteColumns, deleteValues]

export default deleteChallenges
